import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import Statistics from "./Statistics";
import Timer from "./Timer";
import Chart from "./Chart";
import LogTable from "./LogTable";

import { EAAActions } from "../types";

declare var App: any;
declare var storeLocation: string;
declare var templateUrl: string;
declare var eventId: number;

class Live extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { data: "", loading: false };
  }

  componentDidMount() {
    this.getLatestDisplayTemplate();
    App.cable.subscriptions.create(
      // Connection configuration
      {
        channel: "Alerts::EaasChannel",
        roomId: `${storeLocation}`,
      },
      // Pass in connection callbacks
      {
        connected() {
          /* Called when the subscription is ready for use on the server */
        },
        disconnected() {
          /* Called when the subscription has been terminated by the server */
        },
        received: (data: any) => {
          if (data.event_id != eventId) return;
          this.props.setEAAInstant(data);
          this.getLatestDisplayTemplate();
          const sound = document.getElementById("sound-control");
          // @ts-ignore
          if (sound) sound.play();
        },
      },
    );
  }

  getLatestDisplayTemplate = () => {
    this.setState({ loading: true });
    axios
      .get(templateUrl)
      .then(({ data }: any) => {
        this.setState({ data, loading: false });
      })
      .catch((error: any) => {
        console.error(error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { timezone } = this.props;
    const { data, loading } = this.state;

    return (
      <>
        <Timer timezone={timezone} />
        <div className="row">
          <div
            className="col-xs-10 sn-po-dashboard-box"
            style={{ textAlign: "left" }}
          >
            {loading && (
              <i className="fa fa-lg fa-spin fa-spinner import_loading"></i>
            )}
            <div dangerouslySetInnerHTML={{ __html: data }} />
          </div>
          <Statistics />
        </div>
        <Chart />
        <LogTable timezone={timezone} />
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch: Function) => ({
  setEAAInstant: (payload: any) =>
    dispatch({ type: EAAActions.SetInstant, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Live);
